module.exports = __webpack_public_path__ + "assets/img/Nature.0df32b79.png";